<template>
    <el-select :value="value" class="select" :placeholder="$t('shared.pleaseSelectRole')" @change="$emit('input', $event)">
        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
export default {
  name: 'role-selector',
  props: ['value'],
  data() {
    return {
      loading: false,
      roles: [
        {
          id: '1',
          name: 'User'
        },
        {
          id: '2',
          name: 'Admin'
        }
      ]
    }
  }
}
</script>

<style scoped>
.select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/RoleSelector.vue